import { useTranslation } from 'next-i18next'
import { useDispatch } from 'react-redux'
import { Button } from '@fe/common/components/Button'
import { SuccessModal } from '@fe/common/components/SuccessModal'
import { closeExchangeModal } from 'src/state/reducers/exchangeModalReducer'

interface ExchangeSuccessProps {
  handleRepeat: () => void
}

export const ExchangeSuccess: React.FC<ExchangeSuccessProps> = ({
  handleRepeat,
}) => {
  const { t } = useTranslation('transactions')

  const dispatch = useDispatch()

  const handleClose = () => dispatch(closeExchangeModal())

  return (
    <SuccessModal
      successText={t('exchanged-successfully')}
      handleClose={handleClose}
    >
      <Button isSecondary onClick={handleRepeat} testId="repeat_button">
        {t('another-exchange')}
      </Button>

      <Button onClick={handleClose} testId="close_button">
        {t('common:close')}
      </Button>
    </SuccessModal>
  )
}
